<template>
  <div class="flex flex-col gap-y-2">
    <div class="w-full flex justify-between border-b border-brand-gray-300">
      <h2 class="text-xl md:text-2xl text-primary font-medium">
        {{ $t('controlPanel') }}
      </h2>
      <slot name="headerEnd" :header="dashboardHeader"> </slot>
    </div>
    <slot name="row1"></slot>
    <slot name="row2">
      <Form :initial-values="initialValues" class="w-full flex gap-3 items-end" v-slot="{ values }">
        <Field name="fromDate" v-slot="{ field, errors: errs, handleChange }">
          <SimpleDatepicker
            :field="field"
            :errors="errs"
            :label="$t('showFromDate')"
            :default-value="field.value"
            :server-date-format="dateFormat"
            direction="flex-col"
            label-class="w-full text-xs"
            input-class="w-full text-xs"
            @on-change="(date) => handleChange(date)"
          >
          </SimpleDatepicker>
        </Field>
        <Field name="toDate" v-slot="{ field, errors: errs, handleChange }">
          <SimpleDatepicker
            :field="field"
            :errors="errs"
            :label="$t('showToDate')"
            :default-value="field.value"
            :server-date-format="dateFormat"
            max-date="__now__"
            direction="flex-col"
            label-class="w-full text-xs"
            input-class="w-full text-xs"
            @on-change="(date) => handleChange(date)"
          >
          </SimpleDatepicker>
        </Field>
        <button
          class="pe-1.5 mb-1.5 rounded-md bg-primary text-white flex items-center hover:scale-[1.02] active:scale-100 disabled:bg-gray-300 disabled:hover:scale-95 disabled:cursor-not-allowed"
          @click.prevent="$emit('onDateChange', values)"
        >
          <div class="flex justify-center items-center h-full p-2 rounded-s bg-black/10">
            <faMagnifyingGlass class="w-3 fill-white" />
          </div>
          <span class="px-2 tracking-wide text-white text-sm pb-[1px]">
            {{ $t('search') }}
          </span>
        </button>
      </Form>
    </slot>
  </div>
</template>

<script setup>
import faMagnifyingGlass from '@/assets/icons/faMagnifyingGlass.svg?component'
import SimpleDatepicker from '@/components/SimpleForm/Datepicker.vue'
import { DateTime } from 'luxon'
import { Field, Form } from 'vee-validate'
import { onMounted, reactive, computed } from 'vue'

const emit = defineEmits(['onDateChange'])

const dateFormat = 'yyyy-MM-dd'
const nowLxn = computed(() => DateTime.now())

const initialValues = reactive({
  fromDate: nowLxn.value.minus({ days: 30 }).toFormat(dateFormat),
  toDate: nowLxn.value.toFormat(dateFormat)
})

onMounted(async () => {
  emit('onDateChange', initialValues)
})
</script>

<style lang="scss" scoped></style>
